/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class PropertiesPaneDOMV2API
 * @hideconstructor
 * @classdesc Internal API class that is used to manage the v2 properties pane view.
 */
define([], () => {

	class PropertiesPaneDOMV2API {
		/**
		 * @function PropertiesPaneDOMV2API#render
		 * @description returns the view to be rendered
		 */
		render() {}

		/**
		 * @function PropertiesPaneDOMV2API#getProviderId
		 * @description Returns the provider id for the feature
		 * @return {String} DOM feature provider id
		 */
		getProviderId() {}
	}

	return PropertiesPaneDOMV2API;
});